/**
 * The start page's three growth claims (Anand, 31 Oct 26: "claim high numbers
 * like for what it would be for 10k locations under management and talk
 * about growth there, not activities"). Marketing claims set here, not
 * readings, in one file so Anand can set the figures
 * (docs/signup-optimisation-work-orders.md, START_PROOF).
 */
export const START_PROOF = {
  locations: '10,000+',
  locationsLine: 'locations growing with Fly',
  calls: '+43%',
  callsLine: 'more calls in 90 days, on average',
  top3: '2 in 3',
  top3Line: "locations reach Google's top 3 within 60 days",
} as const;

/** The tiles in the order the start page draws them. */
export const START_PROOF_TILES: ReadonlyArray<{ value: string; line: string }> = [
  { value: START_PROOF.locations, line: START_PROOF.locationsLine },
  { value: START_PROOF.calls, line: START_PROOF.callsLine },
  { value: START_PROOF.top3, line: START_PROOF.top3Line },
];

/** B1's public route: the last 7 days of real switch-ons, widened to 30 when fewer than 4. */
export const SIGNUP_PROOF_PATH = '/api/gbp-agent/signup-proof';
